module.exports = __webpack_public_path__ + "img/视频封面13.6bdeb787.png";